<script setup></script>

<template>
  <svg width="32" height="32" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9 7.2H8.8V4.1C8.8 3.7 8.4 3.3 8 3.3C7.6 3.3 7.2 3.7 7.2 4.1V8C7.2 8.4 7.6 8.8 8 8.8H11.9C12.3 8.8 12.7 8.4 12.7 8C12.7 7.6 12.4 7.2 11.9 7.2ZM8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.4C4.5 14.4 1.6 11.5 1.6 8C1.6 4.5 4.5 1.6 8 1.6C11.5 1.6 14.4 4.5 14.4 8C14.4 11.5 11.5 14.4 8 14.4Z"
    />
  </svg>
</template>
